// dependencies
import { format } from "date-fns";
import React, { useMemo } from "react";

import Text from "../../../../../../components/Text";
// components
import { CardBody, CardHeader } from "../../../../components/Card";
import FactorsPolygonChart from "../../../../components/FactorsPolygonChart";
// hooks
import useFactorsPolygonChart from "../../../../components/FactorsPolygonChart/useFactorsPolygonChart";

// store
import useStore from "../../../../store";

import { useCohorts } from "../../../../../../api/hooks";

// styles
import css from "./SatisfactionFactors.module.scss";

const SatisfactionFactors = () => {
	const [filter, month, cohort] = useStore((state) => [
		state.filter,
		state.cohorts.month,
		state.cohorts.cohort,
		state.cohorts.setCohort,
	]);

	const { data: cohortsData } = useCohorts();

	const cohortDetails = useMemo(() => {
		if (cohort) {
			return cohortsData?.cohorts.find((c) => c._id === cohort);
		}
		return null;
	}, [cohort, cohortsData]);

	const { orderedDataSets, isLoadingData, hasError } = useFactorsPolygonChart({
		filter,
		month: month || undefined,
		cohort,
		selectedCohorts: cohortDetails ? [cohortDetails] : [],
		showAllEmployees: cohort === "all" || cohort === null,
	});

	const selectionChip = useMemo(() => {
		const cohortLabel = cohort === "all" || cohort === null ? "All Employees" : cohortDetails?.name;
		if (month) {
			return (
				<div className={css.selectionChip}>
					<Text element="span" size="caption" weight="semi-bold">
						{cohortLabel}
					</Text>
					<Text element="span" size="caption" weight="regular">
						{` ${format(month, "LLLL yyyy")}`}
					</Text>
				</div>
			);
		} else {
			return (
				<div className={css.selectionChip}>
					<Text element="span" size="caption" weight="semi-bold">
						{cohortLabel}
					</Text>
				</div>
			);
		}
	}, [month, cohort]);

	return (
		<>
			<CardHeader
				title={
					<span>
						<Text element="span" size="paragraph-2" weight="semi-bold">
							Satisfaction Factors
						</Text>
					</span>
				}
				info="This chart displays the satisfaction factors of the selected cohort from the satisfaction trendline chart."
				toolBar={selectionChip}
			/>
			<CardBody>
				<div className={css.chartContainer}>
					<div className={css.factorsPolygon}>
						<FactorsPolygonChart
							orderedDataSets={orderedDataSets}
							isLoadingData={isLoadingData}
							hasError={hasError}
							selectedCohort={cohort}
						/>
					</div>
				</div>
			</CardBody>
		</>
	);
};

export default SatisfactionFactors;
